import { ActionFailedError } from "@/app/errors/ActionFailedError";
import { RecaptchaClient } from "@/app/types/security/Recaptcha";
import { Recaptcha as RecaptchaVars } from "@/app/vars/Recaptcha";

export class URecaptcha {
  private static loading: Promise<RecaptchaClient> | null = null;

  public static preload(): void {
    if (!RecaptchaVars.SITE_KEY) {
      return;
    }

    URecaptcha.load().catch(() => {});
  }

  public static load(): Promise<RecaptchaClient> {
    if (URecaptcha.loading) {
      return URecaptcha.loading;
    }

    URecaptcha.loading = new Promise<RecaptchaClient>((resolve, reject) => {
      URecaptcha.preconnect();

      Reflect.set(window, RecaptchaVars.ONLOAD_CALLBACK, () => {
        if (window.grecaptcha) {
          resolve(window.grecaptcha);
        }
      });

      const script = document.createElement("script");
      script.src = RecaptchaVars.SCRIPT_URL;
      script.async = true;
      script.onerror = () => {
        script.remove();
        URecaptcha.loading = null;
        reject(new ActionFailedError("recaptcha_script_failed"));
      };
      document.head.appendChild(script);
    });

    return URecaptcha.loading;
  }

  private static preconnect(): void {
    for (const origin of RecaptchaVars.PRECONNECT_ORIGINS) {
      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = origin;
      link.crossOrigin = "";
      document.head.appendChild(link);
    }
  }
}
